import PropTypes from 'prop-types'
import React from 'react'

const DestinationsField = ({ paramKey, recruiterIds, tagIds, specialTypes }) => {
  if (recruiterIds.length > 0) {
    return recruiterIds.map((id, i) => (
      <input
        key={id}
        type="hidden"
        name={`${paramKey}[recruiter_destinations_attributes][${i}][recruiter_id]`}
        value={id}
      />
    ))
  }

  if (tagIds.length > 0) {
    return tagIds.map((id, i) => (
      <input key={id} type="hidden" name={`${paramKey}[tag_destinations_attributes][${i}][tag_id]`} value={id} />
    ))
  }

  if (specialTypes.length > 0) {
    return specialTypes.map((type, i) => (
      <input key={type} type="hidden" name={`${paramKey}[special_destinations_attributes][${i}][type]`} value={type} />
    ))
  }

  return null
}

DestinationsField.propTypes = {
  paramKey: PropTypes.string.isRequired,
  recruiterIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  tagIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  specialTypes: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default DestinationsField
